import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.md};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.md};
`

export const InputWrapper = styled.div`
  .MuiFormHelperText-root {
    margin-left: 0;
    color: ${theme.colors.support.success};
  }
`

export const InsertRow = styled.div`
  display: flex;
  gap: 8px;
`

export const ButtonWrapper = styled.div`
  margin-top: 17px;
`

export const TableWrapper = styled.div`
  display: grid;
  border-top: 1px solid ${theme.colors.neutral.lighthover};
`

export const ActionButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  outline: none;
  height: ${theme.spacing['2xm']};
  width: ${theme.spacing['2xm']};
  border-radius: ${theme.shapes.borderRadius.sm};
  background: ${theme.colors.alert.danger.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const ModalActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`

export const TotalizerWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`

export const TotalizerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
  padding: ${theme.spacing.sm};
  background-color: ${theme.colors.alert.info.ligther};
  border-radius: 6px;
`

export const TotalizerItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};

  p {
    color: ${theme.colors.primary.main} !important;
  }
  span {
    font-size: ${theme.typography.sizes.xs} !important;
    color: ${theme.colors.neutral.high} !important;
  }
`
